import { sortArrByArr } from '@apprentage/utils';
import { findIndex, isEmpty, isNil, pathOr, propEq } from 'ramda';
import * as ROUTES from '../constants/routes';
import { client, flattenItems } from './contentful';

export const nextTopicRoute = ({ course, currentTopic, topics }) => {
  const currentTopicIndex = findIndex(propEq('id', currentTopic.id))(topics);
  const nextTopic = topics[currentTopicIndex + 1];

  if (nextTopic === undefined) return null;

  const nextTopicFirstEntryId = pathOr(
    null,
    ['sys', 'id'],
    nextTopic.sections[0]
  );

  if (nextTopicFirstEntryId === undefined) return null;

  return `${ROUTES.CLASSES}/${course.id}/${nextTopic.id}/${nextTopicFirstEntryId}`;
};

export const prevTopicRoute = ({ course, currentTopic, topics }) => {
  const currentTopicIndex = findIndex(propEq('id', currentTopic.id))(topics);
  const prevTopic = topics[currentTopicIndex - 1];

  if (prevTopic === undefined) return null;

  const { sections } = prevTopic;

  if (isNil(sections) || isEmpty(sections)) return null;

  const lastEntryIndex = sections.length - 1;
  const prevTopicLastEntryId = pathOr(
    null,
    ['sys', 'id'],
    sections[lastEntryIndex]
  );

  if (prevTopicLastEntryId) {
    return `${ROUTES.CLASSES}/${course.id}/${prevTopic.id}/${prevTopicLastEntryId}`;
  }

  return null;
};

export const fetchTopics = ({ classId, topicIds }) => {
  const config = {
    content_type: 'topic',
    include: 1,
    'fields.classId': classId
  };

  return new Promise((resolve, reject) => {
    client
      .getEntries(config)
      .then((rsp) => {
        const hasItems = Array.isArray(rsp?.items) && rsp.items.length > 0;
        const hasTopicIds = Array.isArray(topicIds) && topicIds.length > 0;
        const items = hasItems ? flattenItems(rsp?.items) : null;
        let list = items;

        if (hasItems && hasTopicIds) {
          list = sortArrByArr(items, topicIds, 'id');
        }

        resolve({
          list,
          count: rsp?.total
        });
      })
      .catch((error) => {
        console.error('fetchTopics', error);
        reject(error);
      });
  });
};
